
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M7.05 17.824l-.705-.71a.24.24 0 0 1 0-.35l5.835-5.835-5.835-5.835a.24.24 0 0 1 0-.35l.705-.71a.255.255 0 0 1 .355 0l6.095 6.1c.439.439.439 1.15 0 1.59l-6.1 6.1a.256.256 0 0 1-.35 0z"}})])
          )
        }
      }
    